import { LoginRedirect } from '../../components/loginPage/LoginRedirect';

export const LoginRedirectPage = () => {
  return (
    <div>
      <LoginRedirect />
    </div>
  );
};
